import clsx from 'clsx';

import styles from './styles.module.scss';

type ClassCodeBadgeProps = {
  code: string;
  isInactive: boolean;
};

export const ClassCodeBadge = ({ code, isInactive }: ClassCodeBadgeProps) => {
  return (
    <span
      className={clsx(styles.classCodeBadge, {
        [styles.inactive]: isInactive,
      })}
    >
      {isInactive ? 'INACTIVE' : code}
    </span>
  );
};
